import { FormSelectOption } from '../entities/form-select-option.entity';

export function toFormSelectOption<T extends { toString: () => string } = string>(
    value: T,
    label?: string,
    disabled: boolean = false,
    disabledInfoMsg?: string
): FormSelectOption<T> {
    return {
        label: label ?? value.toString(),
        value,
        disabled,
        disabledInfoMsg
    };
}
